module.exports = __webpack_public_path__ + "img/ok.ru.f23c72d7.svg";